module.exports = __webpack_public_path__ + "media/customizations/northspur/back-ca008c987fa8bf347195edbcc6bd3131.jpg";